<div class="blog_card blue-hover">
  <img [src]="blog.thumbnail" [alt]="blog.title">
  <div class="blog_details p-2 flex flex-col gap-2">
    <p class="font-bold truncate hover:underline cursor-pointer" hurreyTooltip [tooltip]="blog.title" [position]="postion">{{blog.title}}</p>
    <p class="line-clamp-2" hurreyTooltip [tooltip]="blog.description" [position]="postion">{{blog.description}}</p>
  </div>
</div>
